module.exports = __webpack_public_path__ + "static/media/triangle-fill-down.3cebb794.svg";